import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const ACTION_COLORS = {
  USER: '#3b82f6', PROJECT: '#8b5cf6', PAGE: '#f59e0b',
  PLANNING: '#10b981', ASSEMBLY: '#ec4899', RESOURCE: '#06b6d4',
};

const getActionColor = (action) => {
  const key = Object.keys(ACTION_COLORS).find(k => action?.includes(k));
  return key ? ACTION_COLORS[key] : 'var(--pico-muted-color)';
};

const formatRelativeTime = (ts) => {
  if (!ts) return '';
  const diff = Date.now() - ts;
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(ts).toLocaleDateString([], { month: 'short', day: 'numeric' });
};

const ActivityTimeline = ({ logs, searchQuery, filterAction }) => {
  const { t } = useTranslation();

  const filtered = useMemo(() => {
    return logs.filter(log => {
      if (filterAction !== 'all' && log.action !== filterAction) return false;
      if (searchQuery) {
        const q = searchQuery.toLowerCase();
        const haystack = [log.action, log.actorEmail, log.details?.projectName].filter(Boolean).join(' ').toLowerCase();
        if (!haystack.includes(q)) return false;
      }
      return true;
    });
  }, [logs, filterAction, searchQuery]);

  if (filtered.length === 0) {
    return <p className="home-empty-message">{t('messages.no_messages')}</p>;
  }

  return (
    <div className="home-activity-timeline">
      {filtered.slice(0, 20).map(log => (
        <div key={log.id} className="home-activity-entry">
          <span className="home-activity-dot" style={{ background: getActionColor(log.action) }} />
          <span className="home-activity-action" style={{ color: getActionColor(log.action) }}>
            {log.action?.replace(/_/g, ' ')}
          </span>
          <span className="home-activity-actor">{log.actorEmail || '—'}</span>
          {log.details?.projectName && <span className="home-activity-project">{log.details.projectName}</span>}
          <span className="home-activity-time">{formatRelativeTime(log.timestamp)}</span>
        </div>
      ))}
    </div>
  );
};

export default ActivityTimeline;
